import slice from '../reducer/slice';
import { IProps } from '../types/notice';

type TOperation = (props: IProps) => void;

const { setSuccess } = slice.actions;

const operation: TOperation = (props) => setSuccess(props);

export default operation;
